<template>
  <Layout
    :assetType="assetType"
    :asset="asset"
    active="configure"
    :title="`Configure | ${assetType.name}`"
  >
    <div class="flex-grow-1 flex-column d-flex py-5 bg-light flex-shrink-0">
      <Meta
        :asset="asset"
        :state="state"
        :organisationId="asset.organisation_id"
      />

      <div ref="content">
        <Configure
          @loaded="configureHasLoaded"
          :asset="assetData"
          :assetType="assetType"
          :definitions="definitions"
          :comments="assetData.comments"
          :signatures="signatures"
        />
      </div>

      <Ctas
        v-if="configureLoaded"
        @signed="signed"
        :assetType="assetType"
        :asset="asset.id"
        :contract="asset.contract.id"
        :contractLead="contractLead"
      />
    </div>
  </Layout>
</template>

<script>
import contractState from '@/Mixins/contractState';
import Layout from './Layout.vue';
import Meta from './Contract/Meta.vue';
import Configure from './Contract/Configure.vue';
import Ctas from './Contract/Ctas/Ctas.vue';


export default {
  mixins: [contractState],

  components: {
    Layout,
    Meta,
    Configure,
    Ctas,
  },

  props: {
    assetType: Object,
    asset: Object,
    definitions: Array,
    contractLead: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      assetData: this.asset,
      signatures: this.asset.signatures ? this.asset.signatures : [],
      configureLoaded: false,
    };
  },

  mounted() {
    window.onpopstate = () => {
      location.reload();
    };
  },

  methods: {
    signed(signature) {
      this.signatures.push(signature);
      this.fetchAssetState(this.asset.id);
    },

    configureHasLoaded() {
      this.$nextTick(() => {
        this.configureLoaded = true;
      });
    },
  },
};
</script>
